module.exports = __webpack_public_path__ + "img/d916669.png";